import { render } from "./DynamicInputSwitch.vue?vue&type=template&id=6cff8e37&ts=true"
import script from "./DynamicInputSwitch.vue?vue&type=script&lang=ts"
export * from "./DynamicInputSwitch.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"shared/src/entidades/builder/form/infrastructure/controls/editorTemplates/prime/DynamicInputSwitch.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6cff8e37"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6cff8e37', __exports__)) {
    api.reload('6cff8e37', __exports__)
  }
  
  module.hot.accept("./DynamicInputSwitch.vue?vue&type=template&id=6cff8e37&ts=true", () => {
    api.rerender('6cff8e37', render)
  })

}


export default __exports__